import { render, staticRenderFns } from "./MplsDetails.vue?vue&type=template&id=0facd16c&"
import script from "./MplsDetails.vue?vue&type=script&lang=js&"
export * from "./MplsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports